import { FC } from 'react'
import { useNavigate } from 'react-router-dom'
import { customHistory } from '../../../history'
import { useTrackingService } from '../../../misc/Tracking/useTrackingService'
import { useNavigationOriginTracker } from '../../../core/navigation/useNavigationOriginTracker.hook'

export const NavigationUtils: FC = () => {
  customHistory.navigate = useNavigate()
  useTrackingService()
  useNavigationOriginTracker()

  return null
}
